var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWifiError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 1.25C12.4142 1.25 12.75 1.58579 12.75 2V13C12.75 13.4142 12.4142 13.75 12 13.75C11.5858 13.75 11.25 13.4142 11.25 13V2C11.25 1.58579 11.5858 1.25 12 1.25Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 3.41235C6.37474 3.90389 3.35209 5.4845 1.05164 7.78495C0.758746 8.07785 0.758746 8.55272 1.05164 8.84561C1.34453 9.13851 1.8194 9.13851 2.1123 8.84561C4.14149 6.81642 6.78986 5.40863 9.75 4.92998V3.41235Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75001 7.98157C7.62883 8.42474 5.73275 9.48169 4.2572 10.9573C3.9643 11.2502 3.9643 11.725 4.2572 12.0179C4.55009 12.3108 5.02496 12.3108 5.31786 12.0179C6.52042 10.8154 8.04436 9.93588 9.75001 9.51943V7.98157Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.46275 14.1294C8.10472 13.4874 8.88285 12.9805 9.75001 12.6558V13C9.75001 13.4185 9.86426 13.8103 10.0633 14.1459C9.48445 14.3942 8.96283 14.7506 8.52341 15.1901C8.23051 15.483 7.75564 15.483 7.46275 15.1901C7.16985 14.8972 7.16985 14.4223 7.46275 14.1294Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9367 14.1459C14.5156 14.3942 15.0372 14.7506 15.4766 15.1901C15.7695 15.483 16.2444 15.483 16.5373 15.1901C16.8302 14.8972 16.8302 14.4223 16.5373 14.1294C15.8953 13.4874 15.1172 12.9805 14.25 12.6558V13C14.25 13.4185 14.1357 13.8103 13.9367 14.1459Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6822 12.0179C17.4796 10.8154 15.9557 9.93588 14.25 9.51942V7.98157C16.3712 8.42473 18.2673 9.48169 19.7428 10.9573C20.0357 11.2502 20.0357 11.725 19.7428 12.0179C19.4499 12.3108 18.9751 12.3108 18.6822 12.0179Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 4.92994C16.767 5.33691 19.0581 6.41559 20.9352 7.97662C21.2659 8.25166 21.5838 8.54166 21.8877 8.84559C22.1806 9.13849 22.6555 9.13849 22.9484 8.84559C23.2413 8.5527 23.2413 8.07783 22.9484 7.78493C22.6121 7.44862 22.2603 7.1277 21.8943 6.82332C19.7566 5.04552 17.1316 3.83201 14.25 3.41235V4.92994Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12 20C13.1046 20 14 19.1046 14 18C14 16.8954 13.1046 16 12 16C10.8954 16 10 16.8954 10 18C10 19.1046 10.8954 20 12 20Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifiError);
export default __webpack_public_path__ + "static/media/wifi-error.267478796ddca798caaea14656c61636.svg";
export { ForwardRef as ReactComponent };